module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "unfold",
    staticClass: "layerMB"
  }, [_c('div', [_c('header', {
    staticClass: "top"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoShow),
      expression: "infoShow"
    }]
  }, [_vm._v("更换新手机号后,原手机号" + _vm._s(_vm.oldMobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')) + "将不能再作为登录使用！")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "silver"
  }, [_vm._v("新手机号:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNum),
      expression: "newNum"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.newNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "silver"
  }, [_vm._v("短信验证码:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.securityNum),
      expression: "securityNum"
    }],
    staticClass: "field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.securityNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.securityNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button green",
    on: {
      "click": _vm.send
    }
  }, [(!_vm.waitCode) ? _c('span', [_vm._v("获取短信验证码")]) : _c('span', [_vm._v(_vm._s(_vm.wait) + "s")])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fail),
      expression: "fail"
    }]
  }, [_vm._v("验证码输入不正确，绑定号码失败！")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button",
    class: {
      'green': (_vm.newNum && _vm.securityNum), 'gray': (!_vm.newNum || !_vm.securityNum)
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "button write",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    staticClass: "noticeMask"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f7a2577","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alertMsg/alertMobile.vue
// module id = 1218
// module chunks = 1